import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'monthsToDate' })
export class MonthsToDatePipe implements PipeTransform {

  /* transform(): Pipe que convierte cantidad de meses a periodo -> 24233 = 2019-05
    value: Cantidad de meses
  */
  transform = (value: number): string => `${Math.floor(value % 12 === 0 ? ((value / 12) - 1) : (value / 12))}-${('0' + (value % 12 === 0 ? 12 : value % 12)).slice(-2)}`;

}
